import React, { useContext, useState } from "react";
import Button from "../../../../../common/components/Forms/Button/Button";
import cx from "classnames";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import { FeatureFlag } from "../../../../enums/FeatureFlags";
import Confirmation from "../../../../../common/components/Modals/Confirmation";
import IQuoteCardResult from "../../../../interfaces/results/IQuoteCardResult";
import { useHistory } from "react-router-dom";
import useCart from "../../../../../common/hooks/useCart";
import { QuoteGroupContext } from "../../../../../compare/providers/RootContextProvider";

interface IQuoteCallToActionProps {
    groupId: string;
    className?: string;
    isDisabled?: boolean;
    premium: number;
    url?: string;
    card: IQuoteCardResult;
}

const QuoteCallToAction: React.FC<IQuoteCallToActionProps> = (props) => {
    const {
        groupId,
        className,
        isDisabled,
        premium,
        url,
        card
    } = props;

    const { generateApplicationURL } = useCart();
    const { selectors } = useContext(QuoteGroupContext);

    const [confirmationIsOpen, setConfirmationIsOpen] = useState(false);

    const history = useHistory();

    const {
        result: {providerId}
    } = card;

    const clickCallToActionPopup = () => {
        providerId === 9 && card.productInfo.life || providerId === 9 && card.productInfo.trauma ?
            setConfirmationIsOpen(true) :
            history.push(generateApplicationURL(groupId, card))
    };

    const lifetimeRewardSelected = selectors.isProviderAddOnSelected("LifetimeReward");

    return (
        <React.Fragment>
            {providerId === 9 && card.productInfo.life && lifetimeRewardSelected || providerId === 9 && card.productInfo.trauma && lifetimeRewardSelected ?
                <>
                    <Confirmation
                    isOpen={confirmationIsOpen}
                    onClose={() => setConfirmationIsOpen(false)}
                    url={generateApplicationURL(groupId, card)} />
                    <Button
                        className={cx({
                            [className]: !!className
                        })}
                        component="a"
                        size="s"
                        variant={"calltoaction"}
                        onClick={clickCallToActionPopup}
                        target="_blank"
                        isDisabled={isDisabled}
                        dataAttributes={{
                            "data-ga_action": "apply-button",
                            "data-ga_label": "click",
                            "data-ga_category": "quote-form",
                            "data-ga_value": premium.toString()
                        }}>
                        <SplitTreatments names={[FeatureFlag.QuoteCallToAction]}>
                            {({ treatments, isReady }) => {
                                if (window.splitioFactory && !isReady)
                                    return null;

                                const flagTreatment = treatments[FeatureFlag.QuoteCallToAction].treatment;

                                switch (flagTreatment) {
                                    case "APPLY_NOW":
                                        return <React.Fragment>Apply Now</React.Fragment>;
                                    case "CONTINUE":
                                        return <React.Fragment>Continue</React.Fragment>;
                                    case "SELECT":
                                    default:
                                        return <React.Fragment>Select</React.Fragment>;
                                }
                            } }
                        </SplitTreatments>
                    </Button>
                </> :
                <Button
                    className={cx({
                        [className]: !!className
                    })}
                    component="a"
                    size="s"
                    variant={"calltoaction"}
                    href={url}
                    target="_blank"
                    isDisabled={isDisabled}
                    dataAttributes={{
                        "data-ga_action": "apply-button",
                        "data-ga_label": "click",
                        "data-ga_category": "quote-form",
                        "data-ga_value": premium.toString()
                    }}>
                    <SplitTreatments names={[FeatureFlag.QuoteCallToAction]}>
                        {({ treatments, isReady }) => {
                            if (window.splitioFactory && !isReady) return null;

                            const flagTreatment =
                                treatments[FeatureFlag.QuoteCallToAction].treatment;

                            switch (flagTreatment) {
                                case "APPLY_NOW":
                                    return <React.Fragment>Apply Now</React.Fragment>;
                                case "CONTINUE":
                                    return <React.Fragment>Continue</React.Fragment>;
                                case "SELECT":
                                default:
                                    return <React.Fragment>Select</React.Fragment>;
                            }
                        }}
                    </SplitTreatments>
                </Button>
            }
        </React.Fragment>
    );
};

export default QuoteCallToAction;
